export default __webpack_public_path__ + "static/media/arrow-outline-right.da771dc3.svg";